<script setup>
    import IconHerringBoneRight from "@/components/icons/IconHerringBoneRight.vue";
    import { usePages } from '@/stores/pages'

    const store = usePages();
</script>

<template>
    <div class="hidden md:block absolute top-[20px] md:left-[23px] lg:left-[36px] xl:left-[64px]">
        <ul class="flex text-sm">
            <li class="mr-2" v-for="(breadcrumb, index) in store.currentPage.breadcrumbs" :key=breadcrumb.slug>
                <IconHerringBoneRight v-if="index > 0" class="inline -mt-1 w-[12px] h-[12px] text-blue mr-1" />

                <a v-if="index != store.currentPage.breadcrumbs.length" :href="breadcrumb.slug">
                    <span>{{ breadcrumb.name }}</span>
                </a>
                <span v-else>{{ breadcrumb.name }}</span>
            </li>
        </ul>
    </div>
</template>